import{jsx as _jsx}from"react/jsx-runtime";/**
 * The default container element for a form.
 *
 * @param props The HTML props for the container element.
 * @returns A container element.
 */export const Container=props=>{return /*#__PURE__*/_jsx("div",{"data-component-type":"form-container",...props})};